"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7441],{

/***/ 47441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SentryUserProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32321);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50456);
/* harmony import */ var _getEnv__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4266);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getEmail {\n        me {\n          _id\n          email\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function SentryUserProvider(props) {
    var me = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_4__["default"])(_templateObject())
    }).me;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((0,_getEnv__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)() !== "prod") return null;
        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
            var configureScope = param.configureScope;
            configureScope(function(scope) {
                scope.clear();
                scope.setTag("deviceId", (0,_helpers_auth_getDeviceId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)());
                if (me) {
                    scope.setUser({
                        id: me._id,
                        email: me.email
                    });
                }
            });
        });
    }, [
        me,
        me === null || me === void 0 ? void 0 : me._id
    ]);
    return null;
};


/***/ })

}]);